import { PhoneManagementPage } from "@features/threecx/PhoneManagementPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/tools/phone-management")({ component: PhoneManagementPage });
